<template>

  <div>

    <component :is="el" :label="label" :required="required">
      <i v-if="noForm">{{label}}&nbsp;</i>

      <select-input
        :label="label"
        v-model="formData"
        value-key="value"
        label-value="label"
        :placeholder="placeholder"
        :size="size"
        :list="selects"
        :required="required"
        :disabled="disabled"
        @change="updated" />

    </component>

  </div>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

export default {
  name: 'select-utility',

  mixins: [SiteMixins],

  props: {

    label: {
      type: String,
      default: 'Utility'
    },

    value: {
//      type: [String, Object, Number],
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'normal'
    },

    required: {
      type: Boolean,
      default: false
    },

    fullObject: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: 'Select Util. Provider'
    },

    helpText: {
      type: String,
      default: null
    },

    callback: {
      type: Function,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    updated (org) {
      this.$emit('input', this.fullObject ? org : org.id)
      this.$emit('change', this.fullObject ? org : org.id)
    }

  },



  data () {

    return {
      formData: this.value,
      loading: false,
      selects: this.getConfig().orgUtilities,
      el: this.noForm ? 'div' : 'el-form-item'
    }

  }

}
</script>

<stype scoped>
  .el-select {
    display: inline-block;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// SelectUtility.vue?43fcacd6